module.exports = __webpack_public_path__ + "img/match_bg.b1c4462e.png";